import { SESSION_STORAGE_STARTUP_CONFIG } from '../constants';

let config = {
  registrationServiceUrl: '',
  abnSearchServiceUrl: '',
  aiInstrumentationKey: '',
  trustDeedAttachment: {
    maxFilesCount: 10,
    maxFileSizeInMb: 5,
  },
};

const set = (value) => {
  if (window && window.sessionStorage) {
    window.sessionStorage.setItem(SESSION_STORAGE_STARTUP_CONFIG, JSON.stringify(value));
    config = value;
    return;
  }

  throw Error('sessionStorage is undefined');
};

const get = () => {
  if (window && window.sessionStorage) {
    if (!config) {
      const json = window.sessionStorage.getItem(SESSION_STORAGE_STARTUP_CONFIG);
      if (json) {
        config = JSON.parse(json);
      }
    }
    return config;
  }

  throw Error('sessionStorage is undefined');
};

export default {
  set,
  get,
};
